export default "__VITE_ASSET__C2ZztK9s__"